// extracted by mini-css-extract-plugin
module.exports = {"open-interface-table":"_2QQ8iBMil1d_rHp02pPr3Y"};